var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames, cPointAtOrigin } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { animated, to } from '@react-spring/web';
import { useStaticColors } from '../hooks/use-theme-colors';
import { useSpringValues } from '../hooks/use-spring-values';
var cls = classNames('svg-segment');
export var SvgSegmentDefaultProps = {
  colors: {
    fill: 'yellow'
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), theme.APPLY_COLORS)
});
// -------- Components -------->
var My = {
  NAME: 'SvgSegment',
  Container: styled(animated.path)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var SvgSegment = function (props) {
  var componentProps = useComponentProps(My.NAME, SvgSegmentDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    colors = componentProps.colors;
  var origin = componentProps.origin || {
    x: 0,
    y: 0
  };
  var cPoint = cPointAtOrigin(origin.x, origin.y);
  var d = function (innerRadius, outerRadius, startAngle, endAngle) {
    var innerStartPoint = cPoint(innerRadius, startAngle);
    var innerEndPoint = cPoint(innerRadius, endAngle);
    var outerStartPoint = cPoint(outerRadius, startAngle);
    var outerEndPoint = cPoint(outerRadius, endAngle);
    var largeArcFlag = endAngle - startAngle <= 180 ? 0 : 1;
    return "\n     M".concat(innerStartPoint.cx, " ").concat(innerStartPoint.cy, "\n     A").concat(innerRadius, " ").concat(innerRadius, " 0 0 ").concat(largeArcFlag ? '1' : '0', " ").concat(innerEndPoint.cx, " ").concat(innerEndPoint.cy, "\n     L").concat(outerEndPoint.cx, " ").concat(outerEndPoint.cy, "\n     A").concat(outerRadius, " ").concat(outerRadius, " 0 0 ").concat(largeArcFlag ? '1' : '0', " ").concat(outerStartPoint.cx, " ").concat(outerStartPoint.cy, "\n     ");
  };
  var values = useSpringValues(componentProps);
  var staticColors = useStaticColors(colors);
  return React.createElement(My.Container, {
    d: to([values.innerRadius, values.outerRadius, values.startAngle, values.endAngle], d),
    fill: staticColors.fill,
    colors: colors,
    fillOpacity: values.opacity,
    className: cls.name(className)
  });
};
SvgSegment.cls = cls;
var templateObject_1, templateObject_2;